<template>
    <el-container direction="vertical" class="payroll-list-main">
        <div class="header">
            <el-row>
                <el-col>
                    <div class="title">
                        {{ title }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="main" v-loading="loading">
            <div class="payroll-list-grid">
                <el-col>
                    <div v-for="dateItem in dateList" :key="dateItem.year">
                        <div class="row" @click="handlePositionClick(dateItem)">
                            <div>
                                <i class="el-icon-caret-bottom" v-if="dateItem.isOpened"></i>
                                <i class="el-icon-caret-right" v-else></i>
                                <span class="amount-by-year">
                                    {{ dateItem.year }}:
                                </span>
                                <span>
                                    {{ dateItem.amount ? formatFinance(dateItem.amount) : dateItem.amount }} руб.
                                </span>
                            </div>
                        </div>
                        <template v-if="dateItem.isOpened">
                            <div v-for="monthItem in dateItem.months" :key="monthItem.month">
                                <div class="row" @click="handlePositionMonthClick(monthItem, dateItem.year + '-' + monthItem.month + '-' + '01')">
                                    <div class="pl15">
                                        <i class="el-icon-caret-bottom" v-if="monthItem.isOpened"></i>
                                        <i class="el-icon-caret-right" v-else></i>
                                        <span class="amount-by-month">
                                            {{ getMonthName(monthItem.month) }}:
                                        </span>
                                        <span>
                                            {{ monthItem.amount ? formatFinance(monthItem.amount) : monthItem.amount }} руб.
                                        </span>
                                    </div>
                                </div>
                                <template v-if="monthItem.isOpened">
                                    <div v-for="(position, index) in employersToPositionsList[dateItem.year + '-' + monthItem.month + '-' + '01']" :key="position + index">
                                        <div class="row" @click="handlePositionClick(position)">
                                            <div class="pl30">
                                                <i class="el-icon-caret-bottom" v-if="position.isOpened"></i>
                                                <i class="el-icon-caret-right" v-else></i>
                                                <span class="amount-by-position">
                                                    {{ position.position_name }}:
                                                </span>
                                                <span>
                                                    {{ position.amount ? formatFinance(position.amount) + ' руб.' : '' }}
                                                </span>
                                            </div>
                                        </div>
                                        <template v-if="position.isOpened">
                                            <div v-for="(employer, indexEmployer) in position.employers" :key="employer + indexEmployer">
                                                <div class="row">
                                                    <div class="pl60">
                                                        <span @click="getPayrollInfoForEmployerLink(employer.id, dateItem.year + '-' + monthItem.month + '-' + '01')" class="link">
                                                            <span class="amount-by-name">
                                                                {{ employer.name }}:
                                                            </span>
                                                            <span>
                                                                {{ employer.amount ? formatFinance(employer.amount) + ' руб.' : '' }}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </el-col>
            </div>
        </div>
    </el-container>
</template>

<script>
import localReferences from '@/helpers/localReferences';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSave, faEdit, faTrashAlt, faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/payroll-list.scss';
import dateHelper from '@/helpers/dateHelper';

library.add(faSave, faEdit, faTrashAlt, faUndoAlt);

export default {
    name: 'EmployerPayrollInfo',
    data() {
        return {
            localReferences,
            title: 'Начисление зарплаты',
            dateList: {},
            employersToPositionsList: [{}],
            loading: false
        };
    },
    methods: {
        formatFinance,
        async getDateList() {
            this.loading = true;
            try {
                this.dateList = await this.$store.dispatch('salary/getDateList');
                console.log(this.dateList);
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loading = false;
            }
        },
        async getEmployersToPositionsList() {
            this.loading = true;
            try {
                this.employersToPositionsList = await this.$store.dispatch('salary/getEmployersToPositions');
                console.log(this.employersToPositionsList);
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loading = false;
            }
        },
        handlePositionClick(position) {
            position.isOpened = !position.isOpened;
        },
        handlePositionMonthClick(position, date) {
            position.isOpened = !position.isOpened;
        },
        getPayrollInfoForEmployerLink(employerId, reportDate) {
            this.$router.push({ name: 'salary-payroll-info-employer', params: { employer_id: '' + employerId, report_date: '' + reportDate } });
        },
        getMonthName: function(month) {
            return `${dateHelper.getMonthName(month)}`;
        }
    },
    mounted() {
        this.getEmployersToPositionsList();
        this.getDateList();
    }
};
</script>
